import React, { Component } from 'react';


import ItemDropdown from '../../../dropdowns/ItemDropdown';


class ItemDropdownField extends Component {
  render() {
    const { name, form, label, excludedItems } = this.props;

    return (
      <ItemDropdown 
        name={name}
        label={label}
        form={form}
        multiple={true}
        required={true}
        excluded_items={excludedItems}
      />
    );
  }
}


export default ItemDropdownField;
